import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { uploadFile } from '../../utils';
import { SUCCESS } from '../actionTypes';
import { BASE_URL, getToken } from '../asyncConfig';

export const addAdmin = createAsyncThunk(
  'auth/addUser', async (details, {rejectWithValue, fulfillWithValue}) => {
    try {
      const res = await uploadFile(details.profile_pic, 'profile_pic');
      if(!res.success){
        return rejectWithValue(res.response.data);
      }
      const {metadata} = res;
      const { data } = await axios.post(
        `${BASE_URL}/admin`, 
        {...details, profile_pic: metadata.url},
        {headers: {Authorization: `Bearer ${getToken()}`}}
      );
      return fulfillWithValue(data);
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
)

export const getAdminsFulfilled = (state, action) => {
  console.log('action', action);
  state.status = '';
  state.admins = action.payload;
}

export const getAdminLoginFulfilled = (state, action) => {
  console.log('action', action);
  state.status = SUCCESS;
  state.authState = action.payload.authState;
  localStorage.setItem('wayride_admin', JSON.stringify(action.payload.admin))
  localStorage.setItem('wayride_token', action.payload.token);
  state.message = action.payload.message;
  state.user = action.payload.admin;
}

export const getAllAdmins = createAsyncThunk(
  'auth/users', async (_, {rejectWithValue, fulfillWithValue}) => {
    try {
      const {data} = await axios.get(`${BASE_URL}/admin`, {
        headers: {Authorization: `Bearer ${getToken()}`}
      });
      return fulfillWithValue(data.admins);
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
)

export const userLogin = createAsyncThunk(
  'auth/login', async (credentials, {rejectWithValue, fulfillWithValue}) => {
    try {
      const res =  await axios.post(`${BASE_URL}/admin/login`, credentials);
      return fulfillWithValue({...res.data, authState: 'LOGIN'});
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
)

export const userLogout = createAsyncThunk(
  'auth/logout', async (_, {rejectWithValue, fulfillWithValue}) => {
    try {
      const res =  await axios.get(
        `${BASE_URL}/admin/logout`,
        {headers: {Authorization: `Bearer ${getToken()}`}}
      );
      localStorage.removeItem('wayride_token');
      localStorage.removeItem('wayride_admin');
      return fulfillWithValue({...res.data, authState: 'LOGOUT'});
    } catch (error) {
      return rejectWithValue({...error.response.data, authState: 'LOGOUT'});
    }
  }
)

export const updateSocketID = createAsyncThunk(
  'auth/socket', async (details, {fulfillWithValue, rejectWithValue}) => {
    try {
      const res = await axios.patch(
        `${BASE_URL}/admin/socket/${details.id}`,
        {socket_id: details.socket_id},
        {headers: {Authorization: `Bearer ${getToken()}`}}
      );
      return fulfillWithValue({...res.data, authState: 'AUTH-CHANGE'});
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
)

export const passwordReset = createAsyncThunk(
  'password-reset', async (details, {fulfillWithValue, rejectWithValue}) => {
    try {
      const res = await axios.patch(
        `${BASE_URL}/admin/change-password`, 
        details,
        {headers: {Authorization: `Bearer ${getToken()}`}}
      );
      return fulfillWithValue({...res.data, authState: 'AUTH-CHANGE'});
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
)

export const updateNotificationToken = createAsyncThunk(
  'update-notification', async (notification_token, {fulfillWithValue, rejectWithValue}) => {
    try {
      const res = await axios.put(
        `${BASE_URL}/admin/notifications`, {notification_token},
        {headers: {Authorization: `Bearer ${getToken()}`}}
      );
      return fulfillWithValue({...res.data, authState: 'AUTH-TOKEN-UPDATE'});
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
)

export const updateAdminProfile = createAsyncThunk(
  'update-user', async (details, {fulfillWithValue, rejectWithValue}) => {
    try {
      let url = '';
      if(typeof details.profile_pic !== 'string'){
        const res = await uploadFile(details.profile_pic);
        if(!res.success){
          return rejectWithValue({...res.response.data, authState: 'AUTH-CHANGE'});
        }
        const {metadata} = res;
        url = metadata.url;
      }
      const profile_pic = url === '' ? details.profile_pic: url;
      const res = await axios.patch(
        `${BASE_URL}/admin/profile/update`, 
        {...details, profile_pic},
        {headers: {Authorization: `Bearer ${getToken()}`}}
      );
      return fulfillWithValue(res.data);
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
)